export default "__VITE_ASSET__295d7f90__"